import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import type { CreateWaveConfig, CreateWaveStep } from "@/types/waves.types";
import useCapacitor from "@/hooks/useCapacitor";
import CreateWavesMainSteps from "./main-steps/CreateWavesMainSteps";
import CreateWaveActions from "./utils/CreateWaveActions";
export default function CreateWaveLayout(t0) {
  const $ = _c(24);
  const {
    children,
    config,
    step,
    showActions,
    submitting,
    setStep,
    onComplete
  } = t0;
  const {
    isIos,
    keyboardVisible
  } = useCapacitor();
  let t1;
  if ($[0] !== setStep) {
    t1 = targetStep => setStep(targetStep, "backward");
    $[0] = setStep;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== config.overview.type || $[3] !== step || $[4] !== t1) {
    t2 = <div className="tw-hidden lg:tw-flex lg:tw-w-52 lg:tw-shrink-0 lg:tw-border-r lg:tw-border-solid lg:tw-border-white/[0.06] lg:tw-bg-[#09090B] lg:tw-py-8 lg:tw-pl-3 lg:tw-pr-5"><CreateWavesMainSteps activeStep={step} waveType={config.overview.type} onStep={t1} /></div>;
    $[2] = config.overview.type;
    $[3] = step;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = `tw-min-w-0 tw-flex-1 tw-bg-iron-950 tw-shadow-[-10px_0_30px_rgba(0,0,0,0.5)] ${isIos && !keyboardVisible ? "tw-mb-10" : ""}`;
  let t4;
  if ($[6] !== children) {
    t4 = <div className="tw-w-full tw-flex-1 tw-p-4 lg:tw-p-8">{children}</div>;
    $[6] = children;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== config || $[9] !== onComplete || $[10] !== setStep || $[11] !== showActions || $[12] !== step || $[13] !== submitting) {
    t5 = showActions ? <div className="tw-mt-auto tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-white/[0.06] tw-bg-iron-950/95 tw-px-4 tw-pb-[calc(1rem+env(safe-area-inset-bottom,0px))] tw-pt-4 lg:tw-px-8 lg:tw-pb-[calc(1.25rem+env(safe-area-inset-bottom,0px))] lg:tw-pt-5"><CreateWaveActions setStep={setStep} step={step} config={config} submitting={submitting} onComplete={onComplete} /></div> : null;
    $[8] = config;
    $[9] = onComplete;
    $[10] = setStep;
    $[11] = showActions;
    $[12] = step;
    $[13] = submitting;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t4 || $[16] !== t5) {
    t6 = <div className="tw-relative tw-flex tw-min-h-[34rem] tw-w-full tw-flex-col tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-white/[0.06]">{t4}{t5}</div>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t3 || $[19] !== t6) {
    t7 = <div className={t3}>{t6}</div>;
    $[18] = t3;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t2 || $[22] !== t7) {
    t8 = <div className="tw-h-full tw-w-full lg:tw-flex">{t2}{t7}</div>;
    $[21] = t2;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
}